export default {
	setup: {
		title: "Configura los registros de tu templo",
		optionalTitle: "Registros opcionales",
		progress: "{done} de {total} registros esenciales",
		optionalProgress: "{done} de {total} registros opcionales",
		next: "Próximo paso: {item}",
		open: "Abrir",
		assistantHint: "¿Prefieres ayuda? El asistente hace los registros contigo.",
		cta: "Configurar con el asistente",
		dismiss: "Descartar",
		items: {
			medium: "Médiums",
			linha_espiritual: "Líneas Espirituales",
			guia: "Guías",
			tipo_atendimento: "Tipos de Atención",
			tipo_ritual: "Tipos de Ritual",
			vincular_atendimento: "Vincular una atención al Tipo de Ritual",
			ritual: "Ritual",
			orixa: "Orixás",
			funcao: "Funciones",
			etapa_jornada: "Etapas del Camino",
		},
	},
	greeting: {
		morning: "Buenos días",
		afternoon: "Buenas tardes",
		evening: "Buenas noches",
	},
	activeRitual: {
		title: "Ritual en Curso",
		noRituals: "Sin rituales activos",
		noRitualsHint: "Abre un ritual para empezar a llamar fichas.",
		viewAll: "Ver rituales",
		loadError: "Error al cargar rituales activos",
		live: "En vivo",
		openSince: "Abierto a las {time}",
		openSinceDate: "Abierto el {date}, {time}",
		elapsedHours: "hace {hours}h{minutes}",
		elapsedMinutes: "hace {minutes} min",
		elapsedDay: "hace {days} día",
		elapsedDays: "hace {days} días",
		progressLabel: "atendidas",
		pending: "En la fila",
		inProgress: "En atención",
		completed: "Concluidas",
		noTickets: "Aún no hay fichas emitidas",
	},
	birthdayWidget: {
		title: "Cumpleaños",
		noBirthdays: "Sin cumpleaños próximos",
		today: "Hoy",
		tomorrow: "Mañana",
		inDays: "En {days} días",
	},
	kpi: {
		consultants: "Consultantes",
		mediums: "Médiums",
		tickets: "Fichas",
	},
	charts: {
		weeklyConsultants: "Nuevos Consultantes por Semana",
		monthlyPersons: "Consultantes por Mes",
		monthlyTickets: "Fichas por Mes",
		orixaDistribution: "Hijos por Orixá",
		noData: "Sin datos en el período",
	},
	topConsultants: {
		title: "Consultantes Más Activos",
		noData: "Sin consultantes con fichas",
	},
	upcomingRituals: {
		title: "Próximos Programados",
		noRituals: "Sin rituales programados",
		viewAll: "Ver todos",
	},
};
